<script lang="ts" setup>
	export type NavLinksContext = Array<{
		category: string
		open?: boolean
		list: Array<{
			title: string
			desc: string
			link?:
				| string
				| {
						path: string
						hash?: string
						replace?: boolean
						query?: {
							product: string
							category: string | undefined
						}
				  }
			target?: '_blank' | '_self' | ''
			icon?: {
				name: string
				dir: string
				wrapperClass?: any
				class?: ClassContext
				pathClass?: string
				[id: string]: any
			}
		}>
	}>

	const props = defineProps<{
		links: NavLinksContext
	}>()
	const linkList = ref<NavLinksContext>([])
	defineEmits<{
		(event: 'change'): void
	}>()
	watch(
		() => props.links,
		() => {
			// @ts-ignore
			linkList.value = props.links
		},
		{ immediate: true }
	)
</script>

<template>
	<ul class="flex items-start xl:flex-nowrap flex-wrap md:gap-y-8 flex-col md:flex-row">
		<li
			v-for="(list, index) in linkList"
			:key="'label-' + index"
			class="lg:border-r last:border-r-0 border-base-100 dark:border-gray-600 lg:pr-24 lg:pl-8 first:pl-0 w-full md:w-[unset]"
		>
			<div class="overflow-hidden overflow-y-auto">
				<div
					class="flex items-center justify-between py-4 md:cursor-text cursor-pointer"
					role="button"
					:class="{ 'opacity-0': !list.category }"
					:title="list.category"
					@click="list.open = !list.open"
				>
					<h6 class="font-semibold text-xs text-gray-500 dark:text-gray-300 uppercase">
						{{ list.category }}
					</h6>
					<span
						class="custom-transition-2 md:hidden"
						:class="{ '-rotate-90': !list.open, 'rotate-0': list.open }"
					>
						<tools-icon dir="arrows" icon="caret-down" path-class="stroke-gray-600" />
					</span>
				</div>

				<div
					class="flex flex-col md:max-h-full gap-y-5 md:gap-y-10 px-3 custom-transition-2 overflow-hidden"
					:class="{
						'max-h-0': !list.open && list.category,
						'max-h-[1000px]': list.open || !list.category
					}"
				>
					<nuxt-link
						v-for="(content, index) in list.list"
						:to="content.link ?? ''"
						:key="'list-' + index"
						class="flex gap-x-4"
						:aria-label="content.title"
						:target="content.target ?? '_self'"
						@click="$emit('change')"
					>
						<div
							v-if="content.icon"
							class="flex-none h-[30px] w-[30px] rounded-full border flex items-center justify-center"
							:class="content.icon.wrapperClass"
						>
							<tools-icon v-bind="content.icon" :icon="content.icon.name" />
						</div>

						<div class="flex flex-col">
							<span class="text-gray font-semibold pb-1 text-xs text-gray">{{ content.title }}</span>
							<p class="text-[10px] text-gray-500 max-w-[180px]">
								{{ content.desc }}
							</p>
						</div>
					</nuxt-link>
				</div>
			</div>
		</li>
	</ul>
</template>
